import script from "./PaidStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidStatus.vue?vue&type=script&setup=true&lang=ts"

import "./PaidStatus.vue?vue&type=style&index=0&id=45595e3e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45595e3e"]])

export default __exports__